document.addEventListener("DOMContentLoaded", function() {

    function initRewardsAtcButton() {
        
        const csRewardsAtcButton = document.querySelectorAll('.cs-product-slide .cs-atc-button')    
        const csCartIcon = document.querySelector('#cart-icon-bubble')

        if (window.location.search.indexOf('drawer=open') !== -1) {
            csCartIcon.click()
        }

        csRewardsAtcButton.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                console.log(e.currentTarget)
                addToCartReward(e.currentTarget);
            })
        })
        
        const addToCartReward = (button) => {
            const csDataId = button.getAttribute('data-id')
            var csItem
            let allItems = {
                items: []
            }
            csItem = {                        
                id: parseInt(csDataId),
                quantity: 1
            }
            allItems.items.push(csItem)
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(allItems)
            })
            .then(response => {
                fetch(window.Shopify.routes.root + `cart.json`)
                    .then((response) => response.json())
                    .then((data) => {
                        setTimeout(function() {                            
                            const url = new URL(window.location)
                            url.searchParams.set("drawer", "open")
                            window.location.href = url
                        }, 100)
                })
    
              return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            })
        }
    }     
        
    initRewardsAtcButton()

    function initCartAuto(items) {
        // Ensure `items` is always treated as an array
        if (!Array.isArray(items)) {
            items = [items]; // Wrap the single object in an array
        }
    
        // Create an updates object from the array of items
        let updates = {};
        items.forEach(({ data_id, quantity }) => {
            updates[data_id] = quantity;
        });
    
        // Send the updates to Shopify's cart/update.js endpoint
        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
        })
        .then(response => {
            // Update the URL to open the drawer
            const url = new URL(window.location);
            url.searchParams.set("drawer", "open");
            window.location.href = url;
            return response.json();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    function updateItemsIfNeeded(existingIdsMind, csFreeMindDataIds) {
        let itemsToUpdate = [];

        if (existingIdsMind && csFreeMindDataIds) {
            itemsToUpdate.push({ data_id: csFreeMindDataIds, quantity: 0 });
        }
    
        if (itemsToUpdate.length > 0) {
            initCartAuto(itemsToUpdate);
        } else {
            console.warn('No valid items to update.');
        }
    }

    function updateItemsIfNeededBoth(existingIds, csFreeSampleDataIds, existingIdsPremium, csFreePremiumDataIds) {
        let itemsToUpdate = [];
    
        if (existingIds > 0 && csFreeSampleDataIds) {
            itemsToUpdate.push({ data_id: csFreeSampleDataIds, quantity: 0 });
        }
    
        if (existingIdsPremium > 0 && csFreePremiumDataIds) {
            itemsToUpdate.push({ data_id: csFreePremiumDataIds, quantity: 0 });
        }
    
        if (itemsToUpdate.length > 0) {
            initCartAuto(itemsToUpdate);
        } else {
            console.warn('No valid items to update.');
        }
    }

    function updateItemsIfNeededThree(existingIds, csFreeSampleDataIds, existingIdsPremium, csFreePremiumDataIds, existingIdsMind, csFreeMindDataIds) {
        let itemsToUpdate = [];
    
        if (existingIds > 0 && csFreeSampleDataIds) {
            itemsToUpdate.push({ data_id: csFreeSampleDataIds, quantity: 0 });
        }
    
        if (existingIdsPremium > 0 && csFreePremiumDataIds) {
            itemsToUpdate.push({ data_id: csFreePremiumDataIds, quantity: 0 });
        }

        if (existingIdsMind > 0 && csFreeMindDataIds) {
            itemsToUpdate.push({ data_id: csFreeMindDataIds, quantity: 0 });
        }
    
        if (itemsToUpdate.length > 0) {
            initCartAuto(itemsToUpdate);
        } else {
            console.warn('No valid items to update.');
        }
    }
    

    function initCartProgress() {

        const csClassCsRewardsResults = document.querySelectorAll('.cs-rewards-results')[0]

        const csCartRewards = document.querySelector('#csCartRewards')
        const csFreeSample = document.querySelector('#csFreeSample')
        const csFreePremium = document.querySelector('#csFreePremium')
        const csFreeMind = document.querySelector('#csFreeMind')

        const csSampleCalc = document.querySelector('#csSampleCalc')
        const csFreeShippingCalc = document.querySelector('#csFreeShippingCalc')
        const csFreeExpressCalc = document.querySelector('#csFreeExpressCalc')        
        const csSecretCalc = document.querySelector('#csSecretCalc')
        const csMindCalc = document.querySelector('#csMindCalc')
        

        const csFreeSampleButton = document.querySelector('#csFreeSample button.cs-atc-button')
        const csFreeSampleDataIds = parseInt(csFreeSampleButton.getAttribute('data-id'))

        const csFreePremiumButton = document.querySelector('#csFreePremium button.cs-atc-button')
        const csFreePremiumDataIds = parseInt(csFreePremiumButton.getAttribute('data-id'))

        const csFreeMindButton = document.querySelector('#csFreeMind button.cs-atc-button')
        const csFreeMindDataIds = parseInt(csFreeMindButton.getAttribute('data-id'))

        const csFreeSampleQuantity = document.querySelector(`[data-quantity-variant-id="${csFreeSampleDataIds}"]`)
        if (csFreeSampleQuantity) {
            csFreeSampleQuantity.closest('.cart-item__quantity ').style.display = 'none'
        }

        const csFreePremiumQuantity = document.querySelector(`[data-quantity-variant-id="${csFreePremiumDataIds}"]`)
        if (csFreePremiumQuantity) {
            csFreePremiumQuantity.closest('.cart-item__quantity ').style.display = 'none'
        }

        const csFreeMindQuantity = document.querySelector(`[data-quantity-variant-id="${csFreeMindDataIds}"]`)
        if (csFreeMindQuantity) {
            csFreeMindQuantity.closest('.cart-item__quantity ').style.display = 'none'
        }

        if (csCartRewards) {

            const csCartHighlight = csCartRewards.querySelector('.cs-cart-highlight')
            const csLevel1 = csCartRewards.querySelector('.cs-level-1')
            const csLevel2 = csCartRewards.querySelector('.cs-level-2')
            const csLevel3 = csCartRewards.querySelector('.cs-level-3')
            const csLevel4 = csCartRewards.querySelector('.cs-level-4')
            const csLevel5 = csCartRewards.querySelector('.cs-level-5')

            let totalPrice = 0
        
            fetch('/cart.json')
            .then(response => response.json())
            .then(cartData => {

                const variantIds = cartData.items.map(item => item.variant_id)

                let existingIds = 0
                let existingIdsPremium = 0
                let existingIdsMind = 0

                if (variantIds.includes(csFreeSampleDataIds)) {
                    existingIds = 1
                } else {
                    existingIds = 0
                }

                if (variantIds.includes(csFreePremiumDataIds)) {
                    existingIdsPremium = 1
                } else {
                    existingIdsPremium = 0
                }

                if (variantIds.includes(csFreeMindDataIds)) {
                    existingIdsMind = 1
                } else {
                    existingIdsMind = 0
                }

                totalPrice = cartData.total_price

                const totalPriceMoney = parseFloat((totalPrice / 100).toFixed(2))
                const sampleDifference = (100 - totalPriceMoney).toFixed(2)
                const premiumDifference = (160 - totalPriceMoney).toFixed(2) 
                const mindDifference = (220 - totalPriceMoney).toFixed(2) 

                const csFreeShippingCalcDiff = (90 - totalPriceMoney).toFixed(2)
                const csFreeExpressCalcDiff = (130 - totalPriceMoney).toFixed(2)
                
                if (totalPriceMoney > 0 && totalPriceMoney < 90) {

                    csCartHighlight.style.transform = `scaleX(10%)`

                    csSampleCalc.innerHTML = `$${sampleDifference} more`
                    csFreeSampleButton.disabled = true

                    csSecretCalc.innerHTML = `$${premiumDifference} more`
                    csFreePremiumButton.disabled = true

                    csMindCalc.innerHTML = `$${mindDifference} more`
                    csFreeMindButton.disabled = true

                    csFreeShippingCalc.innerHTML = `$${csFreeShippingCalcDiff} more`
                    csFreeExpressCalc.innerHTML = `$${csFreeExpressCalcDiff} more`

                    updateItemsIfNeededThree(existingIds, csFreeSampleDataIds, existingIdsPremium, csFreePremiumDataIds, existingIdsMind, csFreeMindDataIds)

                } else if (totalPriceMoney >= 90 && totalPriceMoney < 100) {

                    if (totalPriceMoney > 90) {
                        csCartHighlight.style.transform = `scaleX(30%)`
                    } else {
                        csCartHighlight.style.transform = `scaleX(20%)`
                    }

                    csSampleCalc.innerHTML = `$${sampleDifference} more`
                    csFreeSampleButton.disabled = true

                    csSecretCalc.innerHTML = `$${premiumDifference} more`                    
                    csFreePremiumButton.disabled = true

                    csMindCalc.innerHTML = `$${mindDifference} more`
                    csFreeMindButton.disabled = true
                    
                    csLevel1.classList.add('active')
                    csLevel2.classList.remove('active')
                    csLevel3.classList.remove('active')
                    csLevel4.classList.remove('active')
                    csLevel5.classList.remove('active')

                    csFreeShippingCalc.innerHTML = ``
                    csFreeExpressCalc.innerHTML = `$${csFreeExpressCalcDiff} more`

                    updateItemsIfNeededThree(existingIds, csFreeSampleDataIds, existingIdsPremium, csFreePremiumDataIds, existingIdsMind, csFreeMindDataIds)

                } else if (totalPriceMoney >= 100 && totalPriceMoney < 130) {

                    if (totalPriceMoney > 100) {
                        csCartHighlight.style.transform = `scaleX(50%)`
                    } else {
                        csCartHighlight.style.transform = `scaleX(40%)`
                    }
                    csLevel1.classList.add('active')
                    csLevel2.classList.add('active')
                    csLevel3.classList.remove('active')
                    csLevel4.classList.remove('active')
                    csLevel5.classList.remove('active')

                    csSampleCalc.innerHTML = ``
                    csFreeSampleButton.disabled = false

                    if (existingIds > 0) {
                        csFreeSample.classList.remove('active')
                    } else {
                        csFreeSample.classList.add('active')
                    }

                    csSecretCalc.innerHTML = `$${premiumDifference} more`                    
                    csFreePremiumButton.disabled = true

                    csMindCalc.innerHTML = `$${mindDifference} more`
                    csFreeMindButton.disabled = true

                    csFreeShippingCalc.innerHTML = ``
                    csFreeExpressCalc.innerHTML = `$${csFreeExpressCalcDiff} more`

                    updateItemsIfNeededBoth(existingIdsPremium, csFreePremiumDataIds, existingIdsMind, csFreeMindDataIds)

                } else if (totalPriceMoney >= 130 && totalPriceMoney < 160) {

                    if (totalPriceMoney > 130) {
                        csCartHighlight.style.transform = `scaleX(70%)`
                    } else {
                        csCartHighlight.style.transform = `scaleX(60%)`
                    }
                    csLevel1.classList.add('active')
                    csLevel2.classList.add('active')
                    csLevel3.classList.add('active')
                    csLevel4.classList.remove('active')
                    csLevel5.classList.remove('active')

                    csSampleCalc.innerHTML = ``
                    csFreeSampleButton.disabled = false

                    if (existingIds > 0) {
                        csFreeSample.classList.remove('active')
                    } else {
                        csFreeSample.classList.add('active')
                    }

                    csSecretCalc.innerHTML = `$${premiumDifference} more`                    
                    csFreePremiumButton.disabled = true

                    csMindCalc.innerHTML = `$${mindDifference} more`
                    csFreeMindButton.disabled = true

                    csFreeShippingCalc.innerHTML = ``
                    csFreeExpressCalc.innerHTML = ``

                    updateItemsIfNeededBoth(existingIdsPremium, csFreePremiumDataIds, existingIdsMind, csFreeMindDataIds)

                } else if (totalPriceMoney >= 160 && totalPriceMoney < 220) {

                    if (totalPriceMoney > 130) {
                        csCartHighlight.style.transform = `scaleX(90%)`
                    } else {
                        csCartHighlight.style.transform = `scaleX(80%)`
                    }
                    csLevel1.classList.add('active')
                    csLevel2.classList.add('active')
                    csLevel3.classList.add('active')
                    csLevel4.classList.add('active')
                    csLevel5.classList.remove('active')

                    csSampleCalc.innerHTML = ``
                    csFreeSampleButton.disabled = false

                    if (existingIds > 0) {
                        csFreeSample.classList.remove('active')
                    } else {
                        csFreeSample.classList.add('active')
                    }

                    csSecretCalc.innerHTML = ``                    
                    csFreePremiumButton.disabled = false

                    csMindCalc.innerHTML = `$${mindDifference} more`
                    csFreeMindButton.disabled = true

                    csFreeShippingCalc.innerHTML = ``
                    csFreeExpressCalc.innerHTML = ``

                    if (existingIdsPremium > 0) {
                        csFreePremium.classList.remove('active')
                    } else {
                        csFreePremium.classList.add('active')
                    }

                    updateItemsIfNeeded(existingIdsMind, csFreeMindDataIds)

                } else if (totalPriceMoney >= 220) {

                    csClassCsRewardsResults.style.marginTop = '8rem'

                    csCartHighlight.style.transform = `scaleX(100%)`
                    csLevel1.classList.add('active')
                    csLevel2.classList.add('active')
                    csLevel3.classList.add('active')
                    csLevel4.classList.add('active')
                    csLevel5.classList.add('active')

                    csSampleCalc.innerHTML = ``
                    csFreeSampleButton.disabled = false

                    if (existingIds > 0) {
                        csFreeSample.classList.remove('active')
                    } else {
                        csFreeSample.classList.add('active')
                    }

                    csSecretCalc.innerHTML = ``
                    csFreePremiumButton.disabled = false

                    if (existingIdsPremium > 0) {
                        csFreePremium.classList.remove('active')
                    } else {
                        csFreePremium.classList.add('active')
                    }

                    csMindCalc.innerHTML = ``
                    csFreeMindButton.disabled = false

                    if (existingIdsMind > 0) {
                        csFreeMind.classList.remove('active')
                    } else {
                        csFreeMind.classList.add('active')
                    }

                    csFreeShippingCalc.innerHTML = ``
                    csFreeExpressCalc.innerHTML = ``
                }
            })
            .catch(error => console.error('Error fetching cart data:', error))
        }
    }

    setTimeout(() => {
        initCartProgress()    
    }, 100);    

    document.addEventListener('cart:added', function() {
        initCartProgress()
        initRewardsAtcButton()
    })  
    document.addEventListener('cart:updated', function() {
        initCartProgress()
        initRewardsAtcButton()
    })
})